import React, { useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import VideoComponent from "./videoComponent";
import { useAuth } from "../../contexts/authContext/authContext";
import { sendEmail } from "../../services/email.service";
import { EMAIL_CONSTANTS } from "../../constants/emailConstants";
import { useLoader } from "contexts/loaderContext/loaderContext";
import { useToast } from "contexts/toastContext/ToastContext";

const CardComponent = ({
  videoSrc,
  videoWidth,
  videoHeight,
  name,
  price,
  image,
  width,
  height,
  onBookPressed,
  showBookButton = true,
}) => {
  const { user } = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    category: "",
    comment: "",
  });

  const toggleModal = () => setIsModalOpen(!isModalOpen);
  const { showLoader, hideLoader } = useLoader();
  const { successToast, errorToast } = useToast();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    showLoader();
    e.preventDefault();

    const templateParams = {
      to_name: EMAIL_CONSTANTS.TO_NAME,
      from_name: `${formData.name} ${formData.surname}`,
      category: formData.category,
      comment: formData.comment,
      client_email: user?.email || "",
    };

    const response = await sendEmail(templateParams);
    if (response.success) {
      successToast(
        "Form submitted successfully! We’ll get back to you in 24 hours."
      );
      toggleModal();
      setFormData({ name: "", surname: "", category: "", comment: "" });
      hideLoader();
    } else {
      errorToast("Failed to send the form. Please try again.");
      hideLoader();
    }
  };

  return (
    <>
      <Card className="card-blog mb-4" style={{ marginTop: "0px" }}>
        <CardBody className="p-0">
          {videoSrc && (
            <VideoComponent
              src={videoSrc}
              width={videoWidth}
              height={videoHeight}
            />
          )}
          {image && (
            <img src={image} width={width} height={height} alt={name} />
          )}
          <div className="text-center mt-3" style={{ marginBottom: "20px" }}>
            <h6 className="card-category text-info" >{name}</h6>
            {price && <p className="card-category text-info">{price}</p>}
            {showBookButton && (
              // <Button
              //   color="info"
              //   className="learn-more-btn"
              //   onClick={() =>
              //     name === "Public Speaking" ? toggleModal() : onBookPressed()
              //   }
              // >
              //   {name === "Public Speaking" ? "Get A Quotation" : "Book Now"}
              // </Button>
              <Button
                color="info"
                className="learn-more-btn"
                onClick={() => onBookPressed()}
              >
                Book Now
              </Button>
            )}
          </div>
        </CardBody>
      </Card>

      {/* Modal for Quotation Form */}
      <Modal isOpen={isModalOpen} toggle={toggleModal} centered>
        <ModalHeader toggle={toggleModal}>Get A Quotation</ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <Label for="name">Name</Label>
              <Input
                type="text"
                name="name"
                id="name"
                placeholder="Enter your name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </FormGroup>
            <FormGroup>
              <Label for="surname">Surname</Label>
              <Input
                type="text"
                name="surname"
                id="surname"
                placeholder="Enter your surname"
                value={formData.surname}
                onChange={handleChange}
                required
              />
            </FormGroup>
            <FormGroup>
              <Label for="category">Category</Label>
              <Input
                type="select"
                name="category"
                id="category"
                value={formData.category}
                onChange={handleChange}
                required
              >
                <option value="">Select a category</option>
                <option value="School and Universities">
                  School and Universities
                </option>
                <option value="Professional and MCs">
                  Professionals and MCs
                </option>
                <option value="Corporates and Businesses">
                  Corporates and Businesses
                </option>
                <option value="Speaking and Competitions">
                  Speaking and Competitions
                </option>
              </Input>
            </FormGroup>
            <FormGroup>
              <Label for="comment">Comment</Label>
              <Input
                type="textarea"
                name="comment"
                id="comment"
                rows="4"
                placeholder="Tell us about the services you need, including the purpose and timeline"
                value={formData.comment}
                onChange={handleChange}
                required
              />
            </FormGroup>
            <Button color="primary" type="submit" block>
              Submit
            </Button>
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};

export default CardComponent;
